export const commonConstant = {
  SET_LOADER_STATUS: "SET_LOADER_STATUS",
};
